<div class="flex flex-col relative" #dropdownWrapper [ngClass]="{ 'z-[100]': showOptions && !disabled }">
  <label for="control" class="label" (click)="openDropdown()" (keypress)="openDropdown()" tabindex="0"
    >{{ label }}
    @if (label && isRequired) {
      <span class="text-[var(--error-color)]">*</span>
    }
    <div
      class="w-[100%] px-3 flex flex-row border-[1px] border-[var(--header-border)] font-medium text-sm bg-[var(--btn-bg-secondary)] items-center focus:border-[var(--btn-txt-secondary)] focus:outline-none disabled:bg-[var(--bg-input-disabled)] text-[var(--text-primary)] cursor-pointer"
      [ngClass]="{
        'h-[40px] text-sm': size === 'L',
        'h-[32px] text-xs': size === 'M',
        'h-[27px] text-mini': size === 'S',
        'text-[var(--error-color)] border-[var(--error-color)] focus:border-[var(--error-color)]': !!error,
        'disabled:bg-[var(--bg-input-disabled)]': disabled,
        'rounded-l-lg': corners,
        'mt-1': !!label,
        'border-r-0': !!icon,
        'rounded-r-lg': !icon && corners,
      }"
    >
      @if (!selectedLabel) {
        <span class="text-[var(--text-placeholder)]">{{ placeholder || 'Select ' + label }}</span>
      } @else {
        <span>{{ selectedLabel }}</span>
      }
      <svg-icon class="ml-auto" name="dropdown_arrow" size="SM"> </svg-icon>
    </div>
  </label>

  @if (showOptions && !disabled) {
    <div
      [ngClass]="{
        'mt-[40px] text-sm': size === 'L',
        'mt-[32px] text-xs': size === 'M',
        'mt-[27px] text-mini': size === 'S',
        'h-[160px]': options.length > 4,
      }"
      class="absolute top-[-12px] z-[20], w-full overflow-x-hidden overflow-y-auto border-[1px] border-[var(--header-border)] bg-[var(--bg-dropdown-primary)] text-[var(--text-primary)]"
      style="z-index: 2"
    >
      @if (keys) {
        @for (option of options; track $index) {
          <div
            class="whitespace-nowrap"
            [ngClass]="{
              'bg-[var(--bg-option-disabled)] text-[var(--inactive-tab)] pointer-events-none cursor-not-allowed':
                option['hide'],
            }"
          >
            <div
              class="py-2 pl-3 whitespace-nowrap cursor-pointer transition-colors duration-100"
              [ngClass]="{
                'bg-blue-500 text-white': option[keys.value] === control.value,
                'hover:bg-[var(--btn-bg-h-primary)]': option[keys.value] !== control.value,
              }"
              (click)="setValue(option[keys.value], true)"
              (keypress)="({})"
              tabindex="0"
            >
              {{ option[keys.label] }}
            </div>
          </div>
        }
      } @else {
        @for (option of options; track $index) {
          <div class="cursor-pointer">
            <div class="py-2 pl-3" (click)="setValue(option)" (keypress)="({})" tabindex="0">{{ option }}</div>
          </div>
        }
      }
    </div>
  }

  @if (error || getFirstErrorMessage(control.errors); as errorMessage) {
    <p class="text-[var(--error-color)] text-sm">
      {{ errorMessage }}
    </p>
  }
</div>
